import * as React from 'react'
import { Label, inputClass } from './checkout/formParts'
import BillingDetailsFields from './checkout/BillingDetailsFields'
import CouponField from './checkout/CouponField'
import CardFields from './checkout/CardFields'
import WalletButtons from './checkout/WalletButtons'
import PlanChangeTerms from './checkout/PlanChangeTerms'
import PaymentError from './checkout/PaymentError'

// Right column of /upgrade: everything the buyer fills in, on one screen. A
// purchase collects billing details, a coupon and a card (or a wallet); a plan
// change shows its terms and asks for agreement. The card and wallet states
// come from the page, which owns the payment; this only renders them.
export default function CheckoutForm({
    mode,
    email,
    billing,
    details,
    onChangeDetails,
    coupon,
    vat,
    card,
    wallets,
    change,
    payment,
}) {
    const buying = mode === 'buy'
    const processing = payment.status === 'processing'

    return (
        <form
            className="tw-flex tw-flex-col tw-gap-4"
            data-testid="checkout-form"
            onSubmit={event => {
                event.preventDefault()
                if (!payment.canPay || processing) return
                if (buying) payment.onPay()
                else payment.onConfirmChange()
            }}
        >
            {email ? (
                <label className="tw-flex tw-flex-col tw-gap-1">
                    <Label>Email</Label>
                    <input
                        className={`${inputClass} tw-text-muted-foreground`}
                        value={email}
                        readOnly
                        data-testid="checkout-email"
                    />
                </label>
            ) : null}

            {buying ? (
                <>
                    <BillingDetailsFields
                        details={details}
                        onChangeDetails={onChangeDetails}
                        vat={vat}
                    />
                    <CouponField coupon={coupon} />
                    <CardFields card={card} />
                </>
            ) : (
                <PlanChangeTerms
                    preview={change.preview}
                    previewStatus={change.previewStatus}
                    planLabel={change.planLabel}
                    renewalAmount={change.renewalAmount}
                    renewalCurrency={change.renewalCurrency}
                    period={change.period}
                    paymentMethod={billing && billing.paymentMethod}
                    billingPortalUrl={change.billingPortalUrl}
                    billingCountry={change.billingCountry}
                    site={billing && billing.site}
                    agreed={change.agreed}
                    onAgreedChange={change.onAgreedChange}
                    onPaymentMethodAdded={change.onPaymentMethodAdded}
                />
            )}

            <PaymentError error={payment.error} attempts={payment.attempts} />

            <button
                type="submit"
                disabled={!payment.canPay || processing}
                data-testid="payment-pay"
                className="tw-mt-1 tw-w-full tw-cursor-pointer tw-rounded-lg tw-border-0 tw-bg-primary tw-px-5 tw-py-3 tw-text-sm tw-font-semibold tw-text-primary-foreground disabled:tw-cursor-default disabled:tw-opacity-50"
            >
                {processing ? 'Processing…' : payment.label}
            </button>

            {buying ? (
                <WalletButtons
                    wallets={wallets}
                    disabled={processing || payment.finishing}
                />
            ) : null}

            <p className="tw-m-0 tw-text-xs tw-text-muted-foreground">
                {buying
                    ? payment.recurringNote
                    : 'You can change or cancel your plan at any time from your Subscription page.'}
                {billing && billing.testSite
                    ? ' Test site — nothing real is charged.'
                    : ''}
            </p>
        </form>
    )
}
